import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Modal,
  Stack,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";

import {
  EsignRequestDDPIAPICall,
  GetProfileDetailsDDPIAPICall,
  GetStatusDDPIAPICall,
} from "../DDPIAPICalls";

import BankStyles from "./BankProfile.module.scss";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import MainCompleted from "../DDPICompleted/MainSuccess";
import keyboardicon from "../../../Components/assets/Images/panicongrey.svg";
import {
  GetProfileDetailsCommonAPICall,
  LocationCheckAPICall,
} from "../../../shared/APICalls";
import axios from "axios";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const successModalStyles = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  height: "100vh",
  transform: "translate(-50%, -50%)",
  margin: "auto",
  borderRadius: "10px",
  boxShadow: 24,
  padding: "40px 30px",
  outline: "none",
  display: "flex",
};

export default function DDPIProfileDetails() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const params: any = Object.fromEntries(urlParams.entries());
  const pathName = useLocation().pathname;
  const [loading, setloading] = useState(false);
  const [userDeniedLocation, setuserDeniedLocation] = useState(false);
  const [intervalId, setintervalId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [completedStages, setCompletedStages] = useState<any>();
  const [errorMessage, seterrorMessage] = useState("");
  const [rejectMessage, setrejectMessage] = useState("");
  const callBackURL = document.location.href;
  const [checkedOption, setcheckedOption] = useState(false);
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const timerRef = useRef<any>(null);
  const [userData, setUserData] = useState({
    dp_id: "",
    clientCode: "",
    fullName: "",
    mobile: "",
    email: "",
    pan: "",
    poa_client: false,
    TradingPreference: {
      bse_equity: true,
      nse_equity: true,
      mcx_commodities: false,
      nse_commodities: false,
      nse_mutual_funds: false,
      bse_futures_and_options: true,
      nse_futures_and_options: true,
      bse_currency_derivatives: false,
      nse_currency_derivatives: false,
    },
  });
  const [tradingPreference, setTradingPreference] = useState([]);

  const [IPAddress, setIPAddress] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ"
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      LocationCheckAPICall(IPAddress?.trim())
        .then((response: any) => {
          if (response.data.data) {
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {
          seterrorMessage("latitude and longitude not found");
          setTimeout(() => {
            seterrorMessage("");
          }, 5000);
        });
    }
  }, [IPAddress]);
  // console.log("userId",userId,"cookieData",cookieData)

  useEffect(() => {
    // Admin Login

    // getLocation();

    return () => clearInterval(intervalId);
  }, [pathName]);

  useEffect(() => {
    if (childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef]);

  function checkChild() {
    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);
      setloading(false);
      StatusDetails();
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    GetProfileDetails();
  }, []);

  const GetProfileDetails = () => {
    GetProfileDetailsCommonAPICall()
      .then((response: any) => {
        const TP = response.data.data.TradingPreference;

        const filteredData = Object.keys(TP).filter((key) => TP[key] === true);

        const newData: any = filteredData.map((a) => {
          if (a.includes("equity")) {
            return "Equity";
          } else if (a.includes("futures_and_options")) {
            return "Futures and Options";
          } else if (a.includes("mutual_funds")) {
            return "Mutual Funds";
          }
        });

        const uniqueArray = newData.filter(
          (value: any, index: any) => newData.indexOf(value) === index
        );
        // console.log("TP", uniqueArray);
        setTradingPreference(uniqueArray);

        if (response.data?.data) {
          setUserData(response.data.data);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const StatusDetails = () => {
    GetStatusDDPIAPICall()
      .then((response: any) => {
        // console.log("status", response.data.data);
        if (response.data.data.err_msg) {
          setrejectMessage(response.data.data.err_msg);
        }
        if (
          response.data.data.stage === "approved" ||
          response.data.data.stage === "completed"
        ) {
          navigate("/ddpi/completed");
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  const handleNext = () => {
    if (userData?.poa_client) {
      navigate("/ddpi/completed");
    } else {
      setShowModal(true);
    }
  };

  return (
    <>
      {userData?.poa_client ? (
        <MainCompleted />
      ) : (
        <div className={BankStyles.mainWrapper}>
          <div className={BankStyles.wrapper}>
            <div className={BankStyles.step}>
              <img src={keyboardicon} /> Step 1 of 2
            </div>
            <div>
              <p className={BankStyles.Header}>DDPI Details</p>
            </div>
            <p className={BankStyles.subText}>
              View your DDPI information below for confirmation
            </p>
            <div className={BankStyles.txtwrapper}>
              <Grid
                container
                rowSpacing={5}
                columnSpacing={{ xs: 1, sm: 2, md: 5 }}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "#111827", fontWeight: 500 },
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                    }}
                    id="outlined-basic"
                    label="Client Code"
                    variant="outlined"
                    value={userData?.clientCode}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "#111827", fontWeight: 500 },
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                    }}
                    id="outlined-basic"
                    label="Full Name"
                    variant="outlined"
                    value={userData.fullName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "#111827", fontWeight: 500 },
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                    }}
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    value={userData?.email}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "#111827", fontWeight: 500 },
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                    }}
                    id="outlined-basic"
                    label="Mobile"
                    variant="outlined"
                    value={userData?.mobile}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "#111827", fontWeight: 500 },
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                    }}
                    id="outlined-basic"
                    label="DP ID"
                    variant="outlined"
                    value={userData.dp_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "#111827", fontWeight: 500 },
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                    }}
                    id="outlined-basic"
                    label="PAN No"
                    variant="outlined"
                    value={userData.pan}
                  />
                </Grid>
              </Grid>
            </div>

            <div className={BankStyles.buttonStack}>
              <LoadingButton
                loading={loading}
                variant="contained"
                type="submit"
                id="linkUsingIFSCContinueButton"
                className={BankStyles.approveButton}
                sx={{
                  textTransform: "none",
                  fontSize: "13px",
                  marginTop: "20px",
                  width: "200px",
                  height: "50px",
                }}
                onClick={handleNext}
              >
                Enable DDPI
              </LoadingButton>
            </div>
          </div>
          <SnackBar message={errorMessage} />
          <ErrorSnackBar message={rejectMessage} />
          {showModal && (
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={showModal}
              closeAfterTransition
              slotProps={{
                backdrop: {
                  timeout: 500,
                },
              }}
            >
              <Box sx={successModalStyles}>
                <div className={BankStyles.modalWrapper}>
                  <p className={BankStyles.header}>Enable DDPI</p>

                  <div className={BankStyles.checkBoxDiv}>
                    <FormGroup>
                      <FormControlLabel
                        sx={{ alignItems: "flex-start" }}
                        control={
                          <Checkbox
                            name="condition3"
                            sx={{
                              padding: "0px",
                              "&.Mui-checked": {
                                color: "#1F2937",
                              },
                            }}
                            checked={checkedOption}
                            onChange={(event) => {
                              const { checked } = event.target;
                              setcheckedOption(checked);
                            }}
                          />
                        }
                        label={
                          <span className={BankStyles.label}>
                            I accept that the DDPI will allow Firstock Broking
                            Pvt Ltd to debit the securities from my demat
                            account and deliver them to the exchange without the
                            CDSL. T-PIN and OTP to sell shares. There is a
                            charge of ₹100 + GST to enable DDPI that will be
                            deducted from the Firstock Broking Pvt Ltd account
                            balance
                          </span>
                        }
                      />
                    </FormGroup>
                  </div>

                  <p className={BankStyles.note}>
                    <span style={{ fontWeight: 700, color: "black" }}>
                      Note
                    </span>{" "}
                    : Aadhaar of {userData.fullName} to be used for e-sign.
                  </p>
                  <div className={BankStyles.buttonSection}>
                    <div
                      className={BankStyles.cancelButton}
                      onClick={() => {
                        setShowModal(false);
                        setcheckedOption(false);
                      }}
                    >
                      Cancel
                    </div>
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      type="submit"
                      id="linkUsingIFSCContinueButton"
                      className={BankStyles.approveButton}
                      sx={{
                        textTransform: "none",
                        fontSize: "13px",
                        height: "50px",
                        padding: "8px 40px",
                      }}
                      disabled={!checkedOption}
                      onClick={() => {
                        navigate("/ddpi/esign");
                      }}
                    >
                      Continue
                    </LoadingButton>
                  </div>
                </div>
              </Box>
            </Modal>
          )}
        </div>
      )}
    </>
  );
}
